import { render, staticRenderFns } from "./BvLoading.vue?vue&type=template&id=fc28d698&scoped=true&"
import script from "./BvLoading.vue?vue&type=script&lang=ts&"
export * from "./BvLoading.vue?vue&type=script&lang=ts&"
import style0 from "./BvLoading.vue?vue&type=style&index=0&id=fc28d698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc28d698",
  null
  
)

export default component.exports